// extracted by mini-css-extract-plugin
export var banner = "_2z-0";
export var icon = "_2z-1";
export var message = "_2z-2";